import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/global/atoms'

const Select = ({
  meta: { error, touched },
  input: { onChange, value },
  handleOnChange,
  testId,
  ...rest
}) => (
  <Input.Select
    {...rest}
    value={value}
    onChange={(val, data) => {
      onChange(val)
      if (handleOnChange) {
        handleOnChange(val, data)
      }
    }}
    error={touched && error && error}
    testId={testId}
  />
)

Select.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  testId: PropTypes.string,
  handleOnChange: PropTypes.func,
}

export default Select
